import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService } from '../../../../../../services/dialog.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../../../../../utils/utils';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'createcontact-popup',
    templateUrl: './createcontact-popup.component.html',
    styleUrls: ['./createcontact-popup.component.less'],
    standalone: false
})
export class CreateContactPopupComponent implements OnInit {     

    form!: FormGroup
    submitted = false;
    contactCategories: any[] = [];
    subscriptions: any[] = [];
    buttonLabel: string = 'Create';
    buttonIcon: string = 'add';
    availableContacts: any[] = []

    constructor(private http: HttpClient
        , private confimDialog: DialogService
        , private router: Router
        , @Inject(MAT_DIALOG_DATA) public data: any
        , @Inject('BASE_URL') private baseUrl: string
        , public dialogRef: MatDialogRef<CreateContactPopupComponent>
        , private formBuilder: FormBuilder
        , private toastrService: ToastrService

    ) {

        this.confimDialog.tthis = this;
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            contact: ['', this.isCreateAction ? [] :Validators.required],
            contactId: [this.data?.contactId],
            contactName: [this.data?.contactName],
            contactEmail: [this.data?.contactEmail, [Validators.email]],
            contactCategory: [this.data?.contactCategory, [Validators.required]],
        });
        this.isCreateAction ? null : this.GetAllContracts();
        this.getAllContactCategories();
        this.buttonLabel = this.isCreateAction ? 'Create' : 'Save';
        this.buttonIcon = this.isCreateAction ? 'add' : 'save';
    }

    // convenience getter for easy access to form fields
    get f() { return this.form ? this.form.controls : ''; }

    onContactChange(contact) {
        if (contact) {
            this.form.patchValue({
                contactId: contact.ContactId,
                contactName: contact.ContactName,
                contactEmail: contact.ContactEmail,
                contactCategory: contact.ContactCategory,
            });
        } else {
            this.form.patchValue({
                contactName: '',
                contactEmail: '',
                contactCategory: '',
            });
        }
    }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.form)
            if (this.form.invalid) {
                return;
            }
        Utils.httpUpsertContact(
            this.http
            , this.baseUrl
            , this.form.value
            , this
            , function (tthis: CreateContactPopupComponent, result: any) {
                tthis.onBack()
                tthis.dialogRef.close({ event: 'submit' });
                if (result)
                    tthis.toastrService.success(`Contact was ${tthis.data.contactId ? 'updated' : 'created'} successfully!`);
                else
                    tthis.toastrService.error(`Contact could not be ${tthis.data.contactId ? 'updated' : 'created'}. There is an already existing contact with the same email`);
            },
            function (tthis: CreateContactPopupComponent) {
                tthis.toastrService.error(`Contact could not be ${tthis.data.contactId ? 'updated' : 'created'}. Please contact the administrator.`);
            },
        );
    }

    onBack() { }
    getAllContactCategories() {
        Utils.httpGetAllContactCategories(
            this.http,
            this.baseUrl,
            this,
            function (tthis: CreateContactPopupComponent, result: any) {
                tthis.contactCategories = result;
            },
            null
        )
    }
    get isCreateAction() {
        return this.data.action == 'Create';
    }
    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();

    }
    deleteButtonHandler() {
        var id = this.form.get('contact')?.value
        Utils.httpDeleteContact(
            this.http,
            this.baseUrl,
            id,
            this,
            function (tthis: CreateContactPopupComponent, result: any) {
                if (result)
                    tthis.toastrService.success('Contact was deleted successfully!');
                else
                    tthis.toastrService.error('Contact could not be deleted. Please, contact with administrator');
                tthis.dialogRef.close();
            }, this.dialogRef.close()
        )
    }
    GetAllContracts() {
        Utils.httpGetAllContact(
            this.http
            , this.baseUrl
            , this
            , function (tthis: CreateContactPopupComponent, data: any[]) {
                tthis.availableContacts = data;
            },
            null
        ) }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
